import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {

  const [isVisible, setIsVisible] = useState(() => {
    const storedVisibility = localStorage.getItem('isVisible');
    return storedVisibility ? JSON.parse(storedVisibility) : true; 
  });

  useEffect(() => {
    localStorage.setItem('isVisible', JSON.stringify(isVisible));
  }, [isVisible]);

  
  const urlPath = window.location.pathname;
  const lastSegment = urlPath.split('/').pop();

  const handleBar = () => {
    setIsVisible(prevHidebar => !prevHidebar);
  };

  

  return (
    !isVisible ? (
      <div className='navbar'>
        
        <Link to='/create-form' className={lastSegment === "create-form" ? "link link-active" : "link"}>
          <i className="fa-solid fa-square-plus"></i>
        </Link>
        <Link to='/' className={lastSegment === "Information" ? "link link-active" : "link"}>
          <i className="fa-solid fa-list"></i>
        </Link>
        <Link className='link' onClick={() => handleBar()}>
          <i className="fa-solid fa-arrow-right"></i>
        </Link>
        {/* <Link className='link' to='/Notification' >
           <i className="fa-solid fa-comment"></i>
        </Link> */}
      </div>
    ) : (
      <div className='navbar'>
       
        <Link to='/create-form' className={lastSegment === "create-form" ? "link link-active" : "link"}>
          <i className="fa-solid fa-square-plus"></i>SKAPA
        </Link>
        <Link to='/' className={lastSegment === "Information" ? "link link-active" : "link"}>
          <i className="fa-solid fa-list"></i>NYHETER
        </Link>
        <Link className='link' onClick={() => handleBar()}>
          <i className="fa-solid fa-arrow-left"></i>HIDE
        </Link>
        {/* <Link className='link' to='/Notification' >
           <i class="fa-solid fa-comment"></i>TEST
        </Link> */}
      </div>
    )
  );
}

export default Navbar;
